/*  ========================================================================
    # Sections - Teaser - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import Teaser from './Teaser';

const containers = document.querySelectorAll('div[data-react-app="Teaser"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = containers[i].attributes['data-guid']?.value;
  const props = window.reactProps[containerGuid];

  createRoot(containers[i]).render(<Teaser {...props} />);
}
